module.exports = __webpack_public_path__ + "static/paletaRAL-fce82188ae1e48607f6f76b6604f46c9.jpg";